import { c as _c } from "react/compiler-runtime";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ContentError } from '@/layout/ContentLoading';
export default function NotFound() {
  const $ = _c(5);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      color: "neutral.dark"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("styra.message.404");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <ContentError message=""><Typography variant="h5" sx={t0}>404 - {t1}</Typography></ContentError>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}